module.exports = __webpack_public_path__ + "img/btn_2D.e44a75e6.png";